import { Axios } from "./request";

const API_URL = "usersapi/v1/messages/";

export const MESSAGES_API = {
  GetAllMessages: (from, size) => {
    return Axios.get(`${API_URL}GetAllMessages?from=${from}&size=${size}`);
  },
  GetMyDashboardMessages: () => {
    return Axios.get(`${API_URL}GetMyDashboardMessages`);
  },
};
